import React, { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import WhatsInside from "@/components/sections/WhatsInside";
import Benefits from "@/components/sections/Benefits";
import DoctorSection from "@/components/sections/DoctorSection";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import LeadDialog from "@/components/LeadDialog";

const DOCTOR_IMAGE = "https://customer-assets.emergentagent.com/job_spine-health-guide/artifacts/kokd4pyo_WhatsApp-Image-2025-08-20-at-11.47.57.jpeg";
const STRETCHING_IMAGE = "https://static.prod-images.emergentagent.com/jobs/45c01547-d7ff-47e1-9e72-ababbc366198/images/9adccec83da264a99a418a765ab766458b998d54ddcd2b9c3e75d4b0f5e66c29.png";

export default function LandingPage() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const openLead = () => setLeadOpen(true);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar onCTAClick={openLead} />
      <main>
        <Hero onCTAClick={openLead} doctorImage={DOCTOR_IMAGE} />
        <WhatsInside />
        <Benefits onCTAClick={openLead} stretchingImage={STRETCHING_IMAGE} />
        <DoctorSection doctorImage={DOCTOR_IMAGE} />
        <Testimonials />
        <Pricing onCTAClick={openLead} />
        <FAQ />
      </main>
      <Footer />
      <StickyMobileCTA visible={showSticky} onClick={openLead} />
      <LeadDialog open={leadOpen} onOpenChange={setLeadOpen} />
    </div>
  );
}
